import React, { Fragment } from "react";

import { getStyle } from "../../../hooks/use-styles";
import FlexButtons from "../../FlexButtons";
import HexLoader from "../../HexLoader";
import Notification from "../../Notification";
import HexModal from "..";
import HexButton from "../../../ui-kit/HexButtons";

const ConfirmationModal = (props) => {
  const {
    icon,
    onCancel,
    confirmationMessage,
    confirmDescription,
    onConfirm,
    confirmText,
    cancelText,
    loading,
    messageClassName,
    notification,
    notificationClass,
    notificationType,
    showNotificationOnly,
    descriptionColor,
    title,
    showIcon,
    closable,
    className,
    modalClass
  } = props;

  const iconPath = "/assets/icons/";

  return (
    <HexModal
      open={true}
      onClose={onCancel}
      className={`text-center ${className || ""}`}
      title={title}
      closable={closable}
      modalClass={modalClass}
    >
      <Fragment>
        <div className={title ? "mt-24" : ""}>
          {showIcon && (
            <img
              src={`${iconPath}${icon || "warning-icon.svg"}`}
              alt={"confirmation"}
              className="modal-icon"
            />
          )}

          {showNotificationOnly && notification ? (
            <Notification
              message={notification}
              type={notificationType}
              className={notificationClass || ""}
            />
          ) : (
            confirmationMessage && (
              <div className={`notification-text  ${messageClassName}`}>
                {confirmationMessage}
              </div>
            )
          )}

          {confirmDescription && (
            <p
              className="modal-centered-text"
              style={{ color: getStyle(descriptionColor || "primaryBlack") }}
            >
              {confirmDescription}
            </p>
          )}

          {!showNotificationOnly && notification && (
            <Notification
              message={notification}
              type={notificationType}
              className={notificationClass || ""}
            />
          )}
        </div>
        {loading ? (
          <HexLoader />
        ) : (
          <FlexButtons className={"mt-24"}>
            {cancelText && (
              <HexButton
                size="md"
                type={"outline"}
                className="full-width"
                label={cancelText}
                onClick={onCancel}
              />
            )}

            <HexButton
              type="primary"
              size="md"
              onClick={() => onConfirm("accepted")}
              label={confirmText}
              width={{ pixels: 100, unit: "%" }}
              className="text-sm"
            />
          </FlexButtons>
        )}
      </Fragment>
    </HexModal>
  );
};

export default ConfirmationModal;
